import { createReducer } from "@reduxjs/toolkit";

import { AuthStateType } from "../interface";
import * as actions from "./actions";

export const initialState: AuthStateType = {
  // The access token lives in memory only, so on a cold start the session is unknown until
  // the refresh token cookie has been exchanged for one. See the bootstrap saga.
  authentificated: false,
  bootstrapped: false,
  emailForRecoveryPassword: "",
};

const reducer = createReducer(initialState, (builder) => {
  builder.addCase(actions.bootstrap.success, (state, action) => {
    state.authentificated = action.payload.authentificated;
    state.bootstrapped = true;
  });
  builder.addCase(actions.login.success, (state) => {
    state.authentificated = true;
  });
  builder.addCase(actions.logout.success, (state) => {
    state.authentificated = false;
    state.user = undefined;
  });
  builder.addCase(actions.forgotPassword.success, (state, action) => {
    state.emailForRecoveryPassword = action.payload.email;
  });
  builder.addCase(actions.getUser.success, (state, action) => {
    state.user = action.payload.user;
  });
});

export { reducer as AuthReducer };
